import React, { FC, useState } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { getTimeZoneByLocation } from '../Actions/companyActions';
import isEmpty from '../Utilities/is_empty';
import Skeleton from 'react-loading-skeleton';
import { AddressChangeHandler } from '../Pages/AccountDetail/Forms/AddLocationForm';
import { NewLocationModalErrors } from '../Pages/AccountDetail/Modals/AddNewLocationModal';
import { NewDepartmentModalErrors } from '../Pages/AccountDetail/Modals/AddNewDepartmentModal';
import { DeliveryAddressPopupErrors } from './Popups/DeliveryAddressPopUp';
import { useGoogleMapsLoaded } from '../Utilities/customHooks/useGoogleMapsLoaded';

type Props = {
  handleAddress: AddressChangeHandler;
  classnames?: string;
  errors?: DeliveryAddressPopupErrors | NewLocationModalErrors | NewDepartmentModalErrors;
  focusDeliveryAddress?: boolean;
};

const GooglePlacesAutocomplete: FC<Props> = ({
  handleAddress,
  classnames,
  errors,
  focusDeliveryAddress
}) => {

  const [addressLine, setAddressLine] = useState<string>('');
  const [loadingPlace, setLoadingPlace] = useState<boolean>(false);
  
  // Wait for Google Maps Places library to be loaded
  const isGoogleMapsLoaded = useGoogleMapsLoaded('places');
  


  const handleChange = (newAddressLine: string) => {

    if (!isEmpty(newAddressLine)) {
      setAddressLine(newAddressLine);
    } else if (isEmpty(newAddressLine) && !isEmpty(addressLine)) {
      setAddressLine(newAddressLine);
    }

    if (isEmpty(newAddressLine)) {
      handleAddress({ addressLine: '' });
    };
  };

  const handleSelect = (address: string) => {
    let city: string, state: string, streetNumber: string, zipCode: number, street: string;

    if (!isEmpty(address)) {
      setLoadingPlace(true);
      geocodeByAddress(address)
        .then(async results => {
          results && results[0] && results[0]?.address_components?.map((item) => {
            item?.types?.forEach(type => {
              if (type === 'locality') {
                city = item.long_name;
              }

              if (type === 'administrative_area_level_1') {
                state = item.short_name;
              }

              if (type === 'street_number') {
                streetNumber = item.short_name;
              }

              if (type === 'route') {
                street = item.short_name;
              }

              if (type === 'postal_code') {
                zipCode = +item.short_name;
              }
            })
            return true;
          });

          let latLang = await getLatLng(results[0]);
          let response = await getTimeZoneByLocation(latLang?.lat, latLang?.lng);
          let timezone = response;
          handleAddress({
            city,
            state,
            zipCode,
            streetNumber,
            street,
            addressLine: address,
            longitude: latLang.lng,
            latitude: latLang.lat,
            timezone: timezone
          });
          handleChange(address);
          setLoadingPlace(false);
        })
        .then(latLng => console.log('Success', latLng))
        .catch(error => {
          setLoadingPlace(false);
          console.error('Error', error)
        }
        );
    }
  };

  return (
    <>
    {isGoogleMapsLoaded ? <PlacesAutocomplete
      value={addressLine}
      onChange={handleChange}
      onSelect={handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          {loadingPlace ? <Skeleton height={38} /> : <input
            {...getInputProps({
              name: 'addressLine',
              placeholder: 'Search delivery address',
              className: `form-control ${classnames || ''} ${errors?.addressLine ? 'is-invalid' : ''
                }`,
              autoFocus: focusDeliveryAddress ? true : false
            })}
          />}
          <div className='autocomplete-dropdown-container'>
            {/* {loading && <div>Loading...</div>} */}
            {suggestions?.map((suggestion, index) => {
              const className = suggestion.active
                ? 'suggestion-item--active'
                : 'suggestion-item';
              // inline style for demonstration purpose
              const style = suggestion.active
                ? {
                  backgroundColor: '#dee2e6',
                  cursor: 'pointer',
                  padding: '7px',
                  width: '97.5%',
                }
                : {
                  backgroundColor: '#ffffff',
                  cursor: 'pointer',
                  padding: '7px',
                  width: '97.5%',
                };
              return (
                <React.Fragment key={index}>
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                      key: index,
                      onClick: handleSelect
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
    :
    <Skeleton height={10} width={200}/>
    }
    </>
  );
};

export default GooglePlacesAutocomplete;